import {Typography, useTheme} from "@mui/material";
import {ProcessDatePicker} from "components";
import {brazilianTimeZoneCurrentDate} from "global/constants";

import {useFormContext, Controller} from "react-hook-form";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";

type Props = {
  index: number;
  disabled: boolean;
  allVoyages: Voyage[];
};

const VoyageUnloadField = (props: Props) => {
  const {index, disabled, allVoyages} = props;
  const {control} = useFormContext<Process>();
  const {shouldDisableUnload, minDateVoyageUnload} = useValidateVoyages();

  const theme = useTheme();
  return (
    <Controller
      name={
        `boarding.voyages.${index}.cargoUnload` as `boarding.voyages.0.cargoUnload`
      }
      control={control}
      render={({field: {value}}) => (
        <>
          <ProcessDatePicker
            value={value}
            name={`boarding.voyages.${index}.cargoUnload`}
            errorName="Desembarque"
            title={`Desembarque viagem ${index + 1}`}
            minDate={minDateVoyageUnload(index, allVoyages as any)?.date}
            maxDate={brazilianTimeZoneCurrentDate}
            helperText={
              minDateVoyageUnload(index, allVoyages as any)?.message ||
              "Data futura inválida"
            }
            fullWidth
            label="Desembarque"
            disabled={
              disabled ||
              shouldDisableUnload(index, allVoyages as any)?.disabled
            }
          />
          {shouldDisableUnload(index, allVoyages as any)?.message && (
            <Typography variant="subtitle3" color={theme.palette.primary.main}>
              {shouldDisableUnload(index, allVoyages as any)?.message}
            </Typography>
          )}
        </>
      )}
    />
  );
};

export default VoyageUnloadField;
